import { IListProps } from '@vtbhome/juicyfront/components/atoms/Menu';

export enum DefaultSortOptionValues {
    New = 'desc',
    Old = 'asc',
}

export interface DropdownSortOption<T = string> {
    label: string;
    value: T | null;
    disabled?: boolean;
}

export interface DropdownSortProps {
    options: DropdownSortOption[];
    value: DropdownSortOption;
    menuProps?: Omit<IListProps, 'list' | 'children'>;
    onChange: (value: DropdownSortOption) => void;
}
